module.exports = "https://cdn.meeting.tencent.com/assets/events/host/_next/static/images/publish-loading-66e18c98abb2611d4009b732da4f8a73.png";